import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedIn } from '@mui/icons-material';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-container site-footer__inner">
        <div>
          <div className="site-footer__brand">
            <img src="/logo-512.png" alt="" className="site-footer__mark" />
            <span>Decode</span>
            <span className="site-footer__by">by BIM Analytics</span>
          </div>
          <div className="site-footer__copy">
            &copy; {new Date().getFullYear()} BIM Analytics Limited. All rights reserved.
          </div>
          <div className="site-footer__legal">
            Registered in England and Wales, company no. 15872649. Registered office: 7 Bell Yard,
            London WC2A 2JR.
          </div>
        </div>
        <nav className="site-footer__links" aria-label="Footer">
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/terms-of-service">Terms of Service</Link>
          <Link to="/privacy">Privacy</Link>
          <a
            href="https://www.linkedin.com/company/bimanalytics/"
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer__social"
            aria-label="BIM Analytics on LinkedIn"
          >
            <LinkedIn fontSize="inherit" />
            <span>LinkedIn</span>
          </a>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
